import { createReduxStore } from '../../../shared/utils/redux';
import { IApplicationState } from '../../../shared/types/redux';
import { IApplicationContext } from '../../../shared/types/applicationContext';

export function createApplicationState(context: IApplicationContext) {
  const initialState = context.config.getStrict<IApplicationState>('feedback-page.initialState');

  return createReduxStore(initialState, context);
}
